//@flow

/**
 * Represents the root html element of the application.
 * (in general it is not necessary for an application to have a root)
 */
export class ApplicationRoot {
	_rootElementId: string;

	constructor (rootElementId: string){
		if (!rootElementId){
			throw new Error('rootElementId is required!');
		}

		this._rootElementId = rootElementId;
	}

	get rootElementId (): string {
		return this._rootElementId;
	}
}
